import { gql } from 'graphql.macro';

export const fortnoxTokenLoginTemplate = gql`
    mutation fortnoxTokenLogin($authCode: String!) {
        fortnoxTokenLogin(authCode: $authCode)
    }
`;
